import type { ReactNode } from 'react';

export const symbol_stylus_pen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m253-364 83-299q3-10 11-16t18-6h43v-47q0-6 1.5-12t3.5-12l51-117q2-3 4.5-5t6.5-2h10q4 0 6.5 2t4.5 5l51 117q2 6 3.5 12t1.5 12v47h43q10 0 18 6t11 16l83 299q4 14-5 26t-24 12H282q-15 0-24-12t-5-26Zm69-22h316l-65-239H387l-65 239Zm0 0h316-316ZM203-120q-16 0-24.5-12.5T175-160l6-17q8-22 27-35.5t42-13.5h460q23 0 42 13.5t27 35.5l6 17q5 15-3.5 27.5T757-120H203Z"
		/>
	</svg>
);
